import { render } from "./UserCloneModal.vue?vue&type=template&id=b582f1aa&scoped=true&ts=true"
import script from "./UserCloneModal.vue?vue&type=script&lang=ts"
export * from "./UserCloneModal.vue?vue&type=script&lang=ts"

import "./UserCloneModal.vue?vue&type=style&index=0&id=b582f1aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b582f1aa"]])

export default __exports__